var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "composer-attachments" },
    [
      !_vm.somenteLeitura
        ? _c("input", {
            ref: "input",
            staticClass: "composer-attachments__input",
            attrs: {
              type: "file",
              multiple: "",
              accept: _vm.ACEITA,
              disabled: _vm.seletorBloqueado
            },
            on: { change: _vm.onSelecionar }
          })
        : _vm._e(),
      _vm.temItens
        ? _c(
            "ul",
            { staticClass: "composer-attachments__lista" },
            _vm._l(_vm.itens, function(item) {
              return _c(
                "li",
                { key: item.chave, staticClass: "composer-attachments__item" },
                [
                  _c(
                    "div",
                    {
                      staticClass: "composer-attachments__miniatura",
                      class: {
                        "composer-attachments__miniatura--documento": !item.ehImagem
                      },
                      style: item.estiloMiniatura
                    },
                    [
                      item.ehImagem
                        ? _c("img", {
                            staticClass: "composer-attachments__img",
                            attrs: {
                              src: item.preview,
                              alt: item.tituloComDestino,
                              title: item.tituloComDestino
                            },
                            on: {
                              click: function($event) {
                                return _vm.aoClicarNaMiniatura(item)
                              }
                            }
                          })
                        : _c(
                            "button",
                            {
                              staticClass: "composer-attachments__doc-gatilho",
                              attrs: {
                                type: "button",
                                "aria-label": item.rotuloDeAcesso,
                                title: item.rotuloDeAcesso,
                                disabled: item.baixando
                              },
                              on: {
                                click: function($event) {
                                  return _vm.aoClicarNaMiniatura(item)
                                }
                              }
                            },
                            [
                              _c("icon-svg", {
                                staticClass: "composer-attachments__doc-icone",
                                attrs: {
                                  name: item.icone.name,
                                  size: 18,
                                  color: item.icone.color
                                }
                              })
                            ],
                            1
                          ),
                      _vm.comDownload && !item.baixando
                        ? _c(
                            "div",
                            {
                              staticClass:
                                "composer-attachments__selo-download",
                              attrs: { "aria-hidden": "true" }
                            },
                            [
                              _c("icon-svg", {
                                attrs: {
                                  name: "download",
                                  size: 10,
                                  color: "var(--neutral-900)"
                                }
                              })
                            ],
                            1
                          )
                        : _vm._e(),
                      item.baixando
                        ? _c(
                            "div",
                            {
                              staticClass:
                                "composer-attachments__status-baixando",
                              attrs: { "data-teste": "anexo-baixando" }
                            },
                            [
                              _c("v-progress-circular", {
                                attrs: {
                                  indeterminate: "",
                                  size: "20",
                                  width: "2",
                                  color: "white"
                                }
                              })
                            ],
                            1
                          )
                        : _vm._e(),
                      item.enviando
                        ? _c(
                            "div",
                            {
                              staticClass:
                                "composer-attachments__status-enviando"
                            },
                            [
                              _c("v-progress-circular", {
                                attrs: {
                                  indeterminate: "",
                                  size: "20",
                                  width: "2",
                                  color: "white"
                                }
                              })
                            ],
                            1
                          )
                        : _vm._e(),
                      item.comErro
                        ? _c(
                            "div",
                            {
                              staticClass: "composer-attachments__status-erro",
                              attrs: {
                                role: "alert",
                                title: item.mensagemDeErro,
                                "aria-label": item.mensagemDeErro
                              }
                            },
                            [
                              _c("icon-svg", {
                                attrs: {
                                  name: "mdi-alert-circle",
                                  size: 12,
                                  color: "var(--danger)"
                                }
                              })
                            ],
                            1
                          )
                        : _vm._e(),
                      !_vm.somenteLeitura
                        ? _c(
                            "button",
                            {
                              staticClass:
                                "composer-attachments__remover composer-attachments__remover--sobreposto",
                              attrs: {
                                type: "button",
                                "aria-label": _vm.rotuloRemover,
                                title: _vm.rotuloRemover
                              },
                              on: {
                                click: function($event) {
                                  return _vm.remover(item.indice)
                                }
                              }
                            },
                            [
                              _c("icon-svg", {
                                attrs: {
                                  name: "close",
                                  size: 10,
                                  color: "var(--neutral-900)"
                                }
                              })
                            ],
                            1
                          )
                        : _vm._e()
                    ]
                  ),
                  item.destino
                    ? _c(
                        "div",
                        {
                          staticClass:
                            "composer-attachments__destino ia-texto-micro",
                          attrs: { title: item.tituloComDestino }
                        },
                        [
                          _c("icon-svg", {
                            attrs: {
                              name: item.iconeDestino,
                              size: 10,
                              color: "var(--neutral-600)"
                            }
                          }),
                          _c("span", [_vm._v(_vm._s(item.destino))])
                        ],
                        1
                      )
                    : _vm._e()
                ]
              )
            }),
            0
          )
        : _vm._e(),
      _c("TaskCommentAttachmentViewer", {
        ref: "viewer",
        on: { download: _vm.baixarAmpliada }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }